import { createUrl } from 'utils/url';

/**
 * Get a video ID from a URL. Currently supports YouTube.
 *
 * Handled URL formats:
 *
 * - https://www.youtube.com/watch?v=VIDEO_ID
 * - https://youtu.be/VIDEO_ID
 * - https://www.youtube.com/embed/VIDEO_ID
 */
export function getVideoId(url: string) {
	const delimiters = ['watch?v=', 'youtu.be/', 'youtube.com/embed/'];
	for (const delimiter of delimiters) {
		if (url.includes(delimiter)) {
			// Split at the delimiter to get the start of the video ID, e.g.
			// ['https://www.youtube.com', 'VIDEO_ID'] for `watch?v=`, then
			// remove any additional query string arguments.
			return url.split(delimiter)[1]?.split('?')[0]?.split('&')[0] || '';
		}
	}
	return undefined;
}

type Options =
	| { hasAPI: true; origin: string }
	| { hasAPI?: false; origin?: never };

/**
 * Get a video embed URL. Currently supports YouTube.
 */
export function getVideoEmbedUrl(
	videoId: string | undefined,
	{ hasAPI, origin }: Options = {},
) {
	if (!videoId) {
		return undefined;
	}
	// https://developers.google.com/youtube/player_parameters
	return createUrl(`https://www.youtube-nocookie.com/embed/${videoId}`, {
		enablejsapi: hasAPI ? 1 : undefined,
		origin,
		rel: 0,
	});
}
